var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-radio-group',_vm._b({attrs:{"options":_vm.schema.values},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'b-form-radio-group',{ ..._vm.schema, ..._vm.schema.attributes },false))
}
var staticRenderFns = []

export { render, staticRenderFns }